/**
 * Created by anthony on 6/23/14.
 */

var applicationSidebar = angular.module('applicationSidebar');
applicationSidebar.classy.controller({
    name: 'ApplicantInfoController',
    inject: ['$scope', '$modal', 
        'ApplicationService', 'authServiceFactory', 'ModelService', 'CalculationService', 
        'SchoolModelService', 'SliderService', 'GradeSetupModelService', 'ApplicantModelService', 
        'EditApplicantsModalService'],
    init: function()
    {
        this.$.authServiceFactory = this.authServiceFactory
        this.$.SliderService = this.SliderService;
        this.$.$modalInstance = this.$modalInstance;
        this.$.ApplicationService = this.ApplicationService;
        this.$.familyIndex = this.familyIndex;
        this.$.versionNo = versionNo;
        var parent = this;

        this.familyID = this.ApplicationService.getFamilyData().data[0].familyID;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.applicants = this.ApplicationService.getAwardData().applicants;
        this.$.anonymous = this.$.schoolinfo.Anonymous;
        var g = this.GradeSetupModelService.get();
        this.$.grades = [];
        for (var i = 0; i < g.length; i++) {
            if (g[i].InUse==1 && g[i].del==0)
                this.$.grades.push(g[i])
        }

        this.initOpened();
        this.$.activeTabIndex = 0;
        /*this.$.$watch(function() {return parent.$.SliderService.returnSliders();}, function() {
            //set active tab
            console.log("change watch");
            if (parent.$.SliderService.returnSliders().length>0) {
                for (var j = 0; j < parent.$.SliderService.returnSliders().length; j++) {
                    if (parent.$.SliderService.returnSliders()[j].partial.indexOf("applicant") >= 0)
                        var ind = parent.$.SliderService.returnSliders()[j].paramObj.tab
                }
                for (var i = 0; i < parent.$.applicants.length; i++) {
                    parent.$.applicants[i].active = false;
                }
                console.log(ind);
                if (ind!==undefined) {
                    parent.$.applicants[ind].active = true;
                }
            }
        });*/
        this.calcAge(this.getField(this.$.applicants[0], 'App_DOB'));
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
        this.$.confidential = this.authServiceFactory.getAuth().permissions.confidential;
    },
    watch: {
        'this.SliderService.returnSliders()': function(oldValue, newValue) {
            if (this.$.SliderService.returnSliders().length>0) {
                for (var j = 0; j < this.$.SliderService.returnSliders().length; j++) {
                    if (this.$.SliderService.returnSliders()[j].partial.indexOf("pplicant") >= 0)
                        var ind = this.$.SliderService.returnSliders()[j].paramObj.tab
                }
                for (var i = 0; i < this.$.applicants.length; i++) {
                    this.$.applicants[i].active = false;
                }
                if (ind!==undefined) {
                    this.$.applicants[ind].active = true;
                }
            }
        }
    },
    calcAge: function(dob) {
        if (dob) {
            let year = dob.toString().substr(0,4);
            let month = dob.toString().substr(4,2);
            let day = dob.toString().substr(6,8);
            let birth = moment(year + "-" + month + "-" + day);
            let now = moment();
            return now.diff(birth, "years");
        }
    },
    initOpened: function()
    {
        this.edited = Array();
        this.opened = Array();
        this.$.xApp_DOB = Array();
        for (var i = 0; i < this.$.applicants.length; i++) {
            this.$.xApp_DOB[i] = this.$.applicants[i].xApp_DOB.toString().getDateMysqlReversed();
            this.edited[i] = false;
            this.opened[i] = false;
        }
        this.opened[0] = true;
    },
    gradefill: function(index)
    {
        for (var i = 0; i < this.$.grades.length; i++) {
            if (this.$.applicants[index].xApp_Div_Code == this.$.grades[i].DivisionCode) {
                this.$.applicants[index].xApp_Division = this.$.grades[i].divisionDesc;
                this.$.applicants[index].App_Tuition = this.$.grades[i].tuition;
            }
        }
    },
    getField: function(item, field)
    {
        if (item['x' + field] === null || item[field] == item['x' + field])
            return item[field]
        else
            return item['x' + field];
    },
    newDep: function()
    {
        var ind = this.ApplicantModelService.new();
        this.$.applicants[ind].active = 1;
        this.$.activeTabIndex = ind;
        this.initOpened();
    },
    open: function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        this.$.opened = true;
    },
    getOpened: function(index)
    {
        return this.opened[index];
    },
    getEdited: function(index)
    {
        return this.edited[index];
    },
    toggleOpen: function(index)
    {
        if (this.opened[index] == false)
            this.initOpened();
        this.opened[index] = !this.opened[index];

    },
    toggleEdit: function(index)
    {
        var parent = this;
        angular.forEach(this.$.applicants[index], function(value, key) {
            if ((parent.$.applicants[index]['x'+key]!==undefined) && (parent.$.applicants[index]['x'+key]==null)) {
                parent.$.applicants[index]['x'+key] = parent.$.applicants[index][key];
            }
        });
        
        if (this.edited[index] == false)
            this.initOpened();
        this.edited[index] = !this.edited[index];
    },
    dismiss: function()
    {
        this.ApplicationService.getAwardData().applicants.pop();
    },
    startSaveProcess: function(scope, instance, form, index)
    {
        if (form.$valid)
        {
            this.edited[index] = !this.edited[index];
            instance.options.factor = .5;
            this.$.applicants[index].xApp_DOB = this.$.xApp_DOB[index];
            this.$.applicants[index].xApp_DOB = this.$.applicants[index].xApp_DOB.toString().getDateMysqlRegular()
            if ((typeof this.$.applicants[index].recordID !== 'undefined')) {
                this.CalculationService.reCalc();
                return this.ApplicantModelService.put(this.$.applicants[index].recordID, this.$.applicants[index], instance)
            }
            else {
                this.savePut(index);
                this.ApplicantModelService.post(this.familyID, this.$.applicants[index], instance)
                this.livingAllowancePut(1).then(() => {
                    this.CalculationService.reCalc();
                });
            }
        }
        else
            instance.stop(-1);
    },
    startDeleteProcess: function(scope, instance, form, index)
    {
        if (form.$valid)
        {
            var parent = this;
            swal({
                title: "Are you sure?",
                text: "This child will be deleted!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                cancelButtonText: "Cancel",
                closeOnConfirm: false,
                closeOnCancel: true
            },
                function (isConfirm) {
                    if (isConfirm) {
                        instance.options.factor = .5;

                        parent.$.applicants[index].del = 1;
                        parent.ApplicantModelService.purge(parent.$.applicants[index].recordID, parent.$.applicants[index], instance).then(function () {
                            parent.ApplicationService.getAwardData().applicants.splice(index, 1);
                            parent.$.applicants.splice(index, 1);
                            swal({
                                title: "Success!",
                                text: "Your applicant has been deleted.",
                                type: "success",
                                showCancelButton: false,
                                closeOnConfirm: true
                            });
                        });
                        parent.livingAllowancePut(-1);
                    }
                    else {
                        instance.stop(-1);
                    }
                });
        }
        else
            instance.stop(-1);
    },
    successSave: function (scope, instance, index, callback)
    {
        this.edited = Array();
        var parent = this;
        if(instance.options.config.method == "POST")
        {
            this.$.applicants[index].recordID = instance.options.data.id;
        }
        this.initOpened();
        if (typeof callback != 'undefined')
            callback();
    },
    successDelete: function (scope, instance, index)
    {
        this.initOpened();
    },
    livingAllowancePut: function(number)
    {
        var dataThresh = this.ApplicationService.getFamilyData().thresholds;
        var dataEditSums = this.ApplicationService.getFamilyData().edit_sums;

        var putDataThresh = {};
        var putDataEditSums = {};

        putDataThresh.Thresh_Living_Allowance = dataThresh.Thresh_Living_Allowance;
        putDataThresh.Thresh_Allow_Per_Child = dataThresh.Thresh_Allow_Per_Child;

        putDataEditSums.Applicant_Count = parseInt(dataEditSums.Applicant_Count)+number;

        return this.ModelService.FamilyThreshEditSumsService
            .putHelper(dataThresh, dataEditSums, putDataThresh, putDataEditSums);
    },
    savePut: function(index) {
        var parent = this; 
        
        angular.forEach(this.$.applicants[index], function(value, key) {
                if ((parent.$.applicants[index][key]!==undefined) && (parent.$.applicants[index][key]==='')) {
                    parent.$.applicants[index][key] = parent.$.applicants[index]['x'+key];
                }
            }); 
    },
    convert: function(item, index) {
        this.EditApplicantsModalService.setItem(item);
        this.EditApplicantsModalService.setIndex(index);
        let templateUrl =
            "fast/submodules/schoolside/applications/submodules/tabs/submodules/edit/partials/convertModal.html?v=";
        return this.$modal.open({
            templateUrl: templateUrl + versionNo,
            controller: "ConvertModalController",
            backdrop: "static",
            keyboard: false
        });
    }
});
